import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography } from '@comparethemarketau/manor-typography';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { LimitSpecialConditionsXS } from '../common/limit_special_conditions_xs';
import { withQuoteFlatten } from '../common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    container: {
        flexGrow: 1,
        borderTop: `0.1rem solid ${theme.colors.grey300}`,
        borderBottom: `0.1rem solid ${theme.colors.grey300}`,
        padding: '1rem'
    },
    title: {
        color: theme.colors.grey600,
        fontSize: theme.fontSize.xs,
        fontWeight: theme.fontWeight.bold,
        lineHeight: theme.lineHeight.tighter,
        paddingBottom: '1rem'
    }
}));

const _ProductIncludedXs = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { className, productId, productSpecialConditions } = props;

    return (
        <div className={classNames('test-policyProductCard-included-xs', classes.container, className)}>
            <Typography className={classes.title}>SPECIAL CONDITIONS</Typography>
            <LimitSpecialConditionsXS specialConditions={productSpecialConditions} productId={productId} removeTitle/>
        </div>
    );
};

_ProductIncludedXs.propTypes = {
    className: PropTypes.string,
    productId: PropTypes.string,
    productSpecialConditions: PropTypes.string
};

const ProductIncludedXs = withQuoteFlatten(_ProductIncludedXs);

export { ProductIncludedXs };
